module.exports = __webpack_public_path__ + "705511fb09b8104eb1032c2ce222ec52.png";